// A carriable good: a small field medical chest — white-panelled canvas over a
// wooden frame, a red cross stencilled on the lid and two leather straps
// buckled over the top. Authored about its own origin at "held" scale
// (matching wood-bundle / grain-sack), so it drops straight into a carry
// socket on the player or worker avatar via `bakeSockets`.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const CANVAS = "#cbbd93";     // chest body
const WHITE = "#e8e4da";      // lid panel
const CROSS = "#c0392b";      // the red cross
const LEATHER = "#3a2a1a";    // straps
const BRASS = "#b08d3a";      // buckles

export const fieldMedkit = defineModel({
  id: "field-medkit",
  batchId: "wwi",
  name: "Field Medkit",
  tags: ["good", "carriable", "cargo", "medical", "wwi"],
  fits: ["carry"],
  summary: "A strapped canvas medical chest with a red cross — a carriable good.",
  description:
    "A small field medical chest at held scale: canvas body, white lid with a " +
    "stencilled red cross and two leather straps with brass buckles. Mount it " +
    "in a player's or worker's `carry` socket to show the figure running " +
    "supplies to the aid post.",
  author: "Fable 5",
  footprint: 0.08,
  parts: (): Part[] => [
    // the canvas chest body
    { geometry: new THREE.BoxGeometry(0.105, 0.06, 0.08), color: CANVAS, position: [0, 0.03, 0] },
    // white lid overhanging the rim
    { geometry: new THREE.BoxGeometry(0.11, 0.02, 0.085), color: WHITE, position: [0, 0.07, 0] },
    // the red cross stencilled on the lid: two crossed bars, slightly proud
    { geometry: new THREE.BoxGeometry(0.052, 0.004, 0.018), color: CROSS, position: [0, 0.081, 0] },
    { geometry: new THREE.BoxGeometry(0.018, 0.004, 0.052), color: CROSS, position: [0, 0.081, 0] },
    // two leather straps wrapping over the chest
    { geometry: new THREE.BoxGeometry(0.014, 0.084, 0.084), color: LEATHER, position: [0.036, 0.04, 0] },
    { geometry: new THREE.BoxGeometry(0.014, 0.084, 0.084), color: LEATHER, position: [-0.036, 0.04, 0] },
    // brass buckles on the front face
    { geometry: new THREE.BoxGeometry(0.016, 0.01, 0.005), color: BRASS, position: [0.036, 0.05, 0.043] },
    { geometry: new THREE.BoxGeometry(0.016, 0.01, 0.005), color: BRASS, position: [-0.036, 0.05, 0.043] },
  ],
  animations: [],
});
